<onyx-information-heading>
  {{ 'modals.noActiveOrder' | translate }}
</onyx-information-heading>

@if (manualProposalOrderUuid(); as manualProposalOrderUuid) {
  <onyx-message intent="information">
    <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>
    {{ 'issues.manualProposal' | translate }}

    <onyx-button
      variant="ghost"
      [size]="32"
      (click)="orderHelper.openModal(manualProposalOrderUuid)"
    >
      {{ 'labels.showOrder' | translate }}
    </onyx-button>
  </onyx-message>
} @else {
  <onyx-message intent="neutral">
    <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

    {{ 'labels.noMoreOrdersDescription' | translate }}
  </onyx-message>
}
